<template>
    <div class="bulma">
        <div class="modal"
             v-if="show"
             :class="{ 'is-active': show }"
        >

            <div class="modal-background" @click="hideModal"></div>
            <div class="modal-card">

                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{ trans.error_title }}
                    </p>
                    <button
                        class="delete"
                        aria-label="close"
                        @click="hideModal"
                    ></button>
                </header>

                <section class="modal-card-body">
                    <div class="content">
                        {{ trans.editing_session_was_interrupted_message_notification }}
                    </div>
                </section>

                <footer class="modal-card-foot">
                    <button
                        class="button"
                        @click="hideModal"
                    >
                        {{ trans.button_close }}
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: "EditingSessionInterruptedSessionModal",
    props: {
        trans: Object,
    },
    computed: {
        ...mapState('documentEditSession',
            {
                show: 'isSessionInterruptedModalShown',
            }),
    },
    methods: {
        ...mapActions('documentEditSession',
            {
                hideModal: 'hideSessionInterruptedModal',
            }
        ),
    }
}
</script>
